import { useEffect } from 'react';
import { useRouter } from '../shared/router.tsx';
import { Spinner } from '../shared/ui.tsx';

/** Old single-label link (/papers/:id/label) → the shared print page (DYMO label). */
export function PrintLabel({ id }: { id: string }) {
  const { navigate } = useRouter();
  useEffect(() => navigate(`/papers/print?kind=labels&ids=${id}`), [id]);
  return <Spinner />;
}
